import React = require("react")
import { mkWidget, Pair } from "widgets-for-react"
import { List } from "immutable"
import { CookieAccepted, CookiebarState, CookieName, CookieState } from "./cookiebar.types"

export const cookieBar_layout = function () {

  let cookiebar_single = (props: {
    title: string,
    caption_accept: string,
    accept: () => void,
  }) =>
    <div className='cookies'>
      <div className='cookies__inner'>
        <div className='cookies__text'>
          {props.title}
        </div>
        <button className='link' key="cookiebar-accept-key" onClick={props.accept}>
          {props.caption_accept}
        </button>
      </div>
    </div>
  // <div className="cookiebar" key="cookiebar-key" role="alert">
  //     <div className='cookiebar__outer container container--s grid--gutter' key='cookiebar-key'>
  //       <div className='cookiebar__inner' key='cookiebar-key'>
  //         <div key='cookiebar-title-key'>
  //           <p className="cookiebar__title title--xs">{props.title}</p>
  //         </div>
  //         <div className='cookiebar__actions' key='cookiebar-actions-key'>
  //           <div className="cookiebar__action" key="cookiebar-accept-key">
  //             <button className="cookiebar__button link" key="cookiebar-accept-key" onClick={props.accept}>
  //               {props.caption_accept}
  //             </button>
  //           </div>
  //           <div className="cookiebar__action" key="cookiebar-decline-key">
  //             <button className="cookiebar__button link" key="cookiebar-decline-key" onClick={props.decline}>
  //               {props.caption_decline}
  //             </button>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  let cookiebar = (props: {
    title: string,
    text: string,
    show_options_label: boolean,
    show_options: boolean,
    show_options_toggle: () => void,
    caption_accept_all: string,
    caption_decline_all: string,
    caption_apply_settings: string,
    state: List<Pair<CookieName, CookieState>>,
    collapse_cookiebar: () => void,
    accept_all: () => void,
    decline_all: () => void,
    apply_settings: () => void,
    set_single: (cookie_name: CookieName, state: CookieAccepted) => void
  }) => <div className="cookiebar" key="cookiebar-key" role="alert">
      {/* <div className='cookiebar__outer container container--s grid--gutter' key='cookiebar-key'>
        <div className='cookiebar__inner' key='cookiebar-key'>
          <div className='cookiebar__text' key='cookiebar-title-key'>
            <p className="cookiebar__title title--xs">{props.title}</p>
            <div dangerouslySetInnerHTML={{ __html: props.text }} />
          </div>
          <div className='cookiebar__actions' key='cookiebar-actions-key'>
            <div className="cookiebar__action" key="cookiebar-accept-key">
              <button className="cookiebar__button link" key="cookiebar-accept-key" onClick={props.accept_all}>
                {props.caption_accept_all}
              </button>
            </div>
            <div className="cookiebar__action" key="cookiebar-decline-key">
              <button className="cookiebar__button link" key="cookiebar-decline-key" onClick={props.decline_all}>
                {props.caption_decline_all}
              </button>
            </div>
          </div>
          <div className="cookiebar__form">
            <div className={`cookiebar__expand cookiebar__expand--${props.show_options ? 'open' : 'closed'} expander`}>
              <button className='expander__button typo--m' onClick={props.show_options_toggle}>
                {props.show_options_label}
              </button>
              {props.show_options ?
                <ul className="expander__list list">
                  {props.state.map(c => <li className="list__item">
                    <label className={`list__label${c.snd.isAccepted == "yes" ? ' list__label--checked' : ''}`} htmlFor={c.snd.htmlFor}>
                      <input
                        onChange={v => {
                          props.set_single(c.fst, v.target.checked ? "yes" : "no")
                        }}
                        className="list__input"
                        type={"checkbox"}
                        aria-required={c.snd.isDisabled}
                        checked={c.snd.isAccepted == "yes"}
                        disabled={c.snd.isDisabled}
                        id={c.snd.htmlFor}
                        aria-label={c.snd.label}
                      />
                      <span>{c.snd.label}</span>
                    </label>
                  </li>)}
                  <button className="list__button link" key="cookiebar-applysettings-key" onClick={props.apply_settings}>
                    {props.caption_apply_settings}
                  </button>
                </ul>
                : null}
            </div>
          </div>
          <button className="cookiebar__close" key="cookiebar-accept-key" onClick={props.collapse_cookiebar}>
            <span className="sr-text">close cookie bar</span>
          </button>
        </div>
      </div> */}
    </div>

  return {
    cookiebar,
    cookiebar_single
  }
}
